import angular from 'angular';
import imgFlag from './imgFlag';

export default angular
  .module('components.imgFlag', [])
  .component('imgFlag', imgFlag).name;
